module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/mentors__03-70e2c80d20d71bb92eff95c37820abb0.jpg";